<template>
  <div class="how-active">
    <div class="ha-des">
      <p class="black">问：什么是缓存？如何清理缓存？</p>
      <p>答：缓存是您在使用APP时产生的一些数据，比如您在某一次作业做到一半时退出，我们会帮您缓存这部分作业数据，方便您下次进入作业时可以在原来的进度上继续进行，无需重新开始。不过APP内的缓存太多时会降低软件运行速度，若您想要清理缓存，建议您在已经提交了所有作业时，再清除缓存。</p>
      <p>在“我的”页面点击【设置】，再点击【清除缓存】，即可清除所有缓存。</p>
<div class="ha-img">
      <img src="./img/clear-cache.png" alt="">
    </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  mounted(){

  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-active {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
</style>
